import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { HOUR_IN_MS } from '@office-start/date-utility';
import { fetchEncryptionKey } from '@office-start/identity-service';
import { createSimpleStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { createEncryptionPlugin, createExpirationPlugin, readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getQueryParams } from '@office-start/url-parser-utility';
import { getUnifiedStorageQuota } from '../operations/getUnifiedStorageQuota';
var unifiedStoragePersistenceKey = 'graph-unified-storage-api';
var unifiedStoragePersistenceVersion = 1;
export function executeUnifiedStorageDataFlow(officeComponentContext, identity, sharedContext, handleRevalidation) {
    return __awaiter(this, void 0, void 0, function () {
        var officeHomeApiRoot, jwtAuthEnabled, correlationId, getAccessToken, inMockMode, encryptionKey, pluginsForWrite, queryParams, hasMockAuth, options, storagePersistenceKey;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    officeHomeApiRoot = officeComponentContext.officeHomeApiRoot, jwtAuthEnabled = officeComponentContext.jwtAuthEnabled, correlationId = officeComponentContext.correlationId, getAccessToken = officeComponentContext.getAccessToken, inMockMode = officeComponentContext.inMockMode;
                    return [4 /*yield*/, fetchEncryptionKey()];
                case 1:
                    encryptionKey = _a.sent();
                    pluginsForWrite = [];
                    queryParams = getQueryParams(location.search);
                    hasMockAuth = queryParams['mockauth'] === '1';
                    if (encryptionKey === null || encryptionKey === void 0 ? void 0 : encryptionKey.key) {
                        pluginsForWrite.push(createEncryptionPlugin(encryptionKey.key));
                    }
                    //do not cache in mock mode
                    pluginsForWrite.push(createExpirationPlugin(inMockMode || hasMockAuth ? -1 : 4 * HOUR_IN_MS));
                    options = {
                        officeApiRoot: officeHomeApiRoot,
                        jwtAuthEnabled: jwtAuthEnabled,
                        correlationId: correlationId,
                        getAccessToken: getAccessToken,
                        graphApiRoot: sharedContext.graphApiRoot,
                        userId: inMockMode ? identity.puid : identity.userPrincipalName,
                        inMockMode: inMockMode,
                    };
                    storagePersistenceKey = "".concat(options.userId);
                    return [2 /*return*/, createSimpleStaleWhileRevalidateOperation(function () { return getUnifiedStorageQuota(options); }, function () {
                            // Reverse order of plugins used for write so they play back
                            // in the correct order.
                            var pluginsForRead = __spreadArray([], __read(pluginsForWrite), false).reverse();
                            return readFromSimplePersistence({
                                userId: identity.puid,
                                collectionName: unifiedStoragePersistenceKey,
                                collectionVersion: unifiedStoragePersistenceVersion,
                                key: storagePersistenceKey,
                                plugins: pluginsForRead,
                            });
                        }, function (networkPayload) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, writeToSimplePersistence({
                                            userId: identity.puid,
                                            collectionName: unifiedStoragePersistenceKey,
                                            collectionVersion: unifiedStoragePersistenceVersion,
                                            key: storagePersistenceKey,
                                            data: networkPayload,
                                            plugins: pluginsForWrite,
                                            writeBehavior: 'sync',
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, handleRevalidation)];
            }
        });
    });
}
//# sourceMappingURL=executeUnifiedStorageDataFlow.js.map